import { styled } from '@nykaa/ui-components';

export const Wrapper = styled.div<{ isCollapsedView: boolean }>`
  position: relative;

  ${({ isCollapsedView, theme }) =>
    !isCollapsedView &&
    `padding-bottom: ${theme.spacing.spacing40};
    border-top: 1px solid ${theme.colors.textDecorative};
    border-bottom: 1px solid ${theme.colors.textDecorative};
    `};
`;
